import * as React from 'react';

const FormContent = React.createContext();

export default FormContent;